import { render } from "./ZapiProductImage.vue?vue&type=template&id=4675a679&scoped=true"
import script from "./ZapiProductImage.vue?vue&type=script&lang=js"
export * from "./ZapiProductImage.vue?vue&type=script&lang=js"

import "./ZapiProductImage.vue?vue&type=style&index=0&id=4675a679&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4675a679"]])

export default __exports__